<template>
  <div id="App">
    <van-nav-bar
      :title="title"
      :left-text="showReturn ? '返回' : ''"
      :left-arrow="showReturn"
      :right-arrow="showRight"
      :right-text="showRight ? '移动考勤' : ''"
      @click-left="onClickLeft"
      @click-right="showAction = true"
    />
    <van-tabs swipeable @change="onLoad" animated v-model="monthActive">
      <van-tab
        v-for="index in 12"
        :key="index"
        :name="index"
        :title="getTitle(index)"
      >
        <van-calendar
          :show-title="false"
          :show-subtitle="false"
          :poppable="false"
          :show-confirm="false"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          :default-date="confirmDate"
          @confirm="onConfirm"
        />
        <van-list
          style="margin-top: -15px"
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="onLoad()"
          ><van-divider></van-divider>
          <van-cell
            v-for="item in list"
            :key="item.CODE"
            :title="item.TIME"
            :value="item.STATUS"
            :style="'background:#ee0a24;color:white;'"
            value-class="wzt"
            is-link
            @click="onClickCell(item)"
          />
        </van-list>
      </van-tab>
    </van-tabs>
    <Tabbar></Tabbar>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper">
        <van-image class="block" fit="contain" :src="photoUrl" />
      </div>
    </van-overlay>

    <van-action-sheet
      v-model="showAction"
      @select="onSelect"
      cancel-text="取消"
      description="移动考勤"
      close-on-click-action
    >
      <div class="content">
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell title="上班考勤" clickable @click="radio = '01'">
              <template #right-icon>
                <van-radio name="01" />
              </template>
            </van-cell>
            <van-cell title="下班考勤" clickable @click="radio = '02'">
              <template #right-icon>
                <van-radio name="02" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <center>
          <van-uploader
            v-model="kqzp"
            multiple
            v-if="isiOS"
            max-count="1"
            :after-read="afterKqzpRead"
            preview-size="160"
            style="margin-top:20px;"
          />
          <van-uploader
            v-model="kqzp"
            multiple
            capture="camera"
            v-if="!isiOS"
            max-count="1"
            :after-read="afterKqzpRead"
            preview-size="160"
            style="margin-top:20px;"
          />
          <van-cell
            title="考勤照片"
            class="zz-title"
            style="text-align: center;"
          />
        </center>
        <van-button round block type="danger" @click="onYDKQ()">
          确认
        </van-button>
      </div>
    </van-action-sheet>
    <van-overlay :show="loadingfinished">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>

<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 100%;
}
.custom-title {
  margin-right: 4px;
  vertical-align: right;
}
.zc {
  color: #1989fa;
}
.wzt {
  color: white;
}
.content {
  width: 100%;
  align-items: center;
  justify-content: center;
}
.zz-title {
  color: lightslategray;
  text-align: left;
}
</style>

<script>
import { mapState } from "vuex";
import Tabbar from "@/components/Tabbar.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      isiOS: false,
      minDate: new Date(
        new Date(Date.now()).getFullYear(),
        new Date(Date.now()).getMonth(),
        1
      ),
      maxDate: new Date(
        new Date(Date.now()).getFullYear(),
        new Date(Date.now()).getMonth() + 1,
        0
      ),
      monthActive: 1,
      title: this.$route.query.Worker,
      workerName: this.$route.query.Worker,
      showReturn: true,
      showRight: false,
      list: [],
      loading: false,
      finished: false,
      confirmDate: new Date(Date.now()),
      listDate: [],
      loadingTimes: 0,
      showOverlay: false,
      loadingfinished: false,
      photoUrl: "",
      showAction: false,
      kqzp: [],
      radio: "01",
      YDKQ: {
        WorkerCode: "",
        RYZP: "",
        scoreLine: 0
      }
    };
  },
  components: {
    Tabbar
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    getTitle(index) {
      var newDate = new Date(Date.now());
      newDate.setMonth(newDate.getMonth() - index + 1);
      return newDate.getMonth() + 1 + "月";
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickCell(key) {
      this.showOverlay = true;
      this.photoUrl = key.PHOTOURL;
    },
    onConfirm(date) {
      this.loading = true;
      this.confirmDate = date;
      var that = this;
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatWokerInfo",
            Params: [
              that.$route.query.ID,
              that.$route.query.Code,
              that.userInfo.loginType,
              that.confirmDate.getFullYear() +
                "-" +
                (that.confirmDate.getMonth() + 1) +
                "-" +
                that.confirmDate.getDate()
            ]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.list = response.data.Table;
            that.finished = true;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = true;
          }
        })
        .catch(error => {
          //弹出失败提醒
          Dialog({ message: error.message });
          that.finished = true;
        });
    },
    onLoad() {
      var that = this;
      var newDate = new Date(Date.now());
      if (that.loadingTimes == 0) {
        that.loadingTimes = 1;
        if (that.$route.query.Day != 1) {
          newDate.setDate(newDate.getDate() - that.$route.query.Day + 1);
        }
        newDate.setMonth(newDate.getMonth() - that.monthActive + 1);
        that.minDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
        that.maxDate = new Date(
          newDate.getFullYear(),
          newDate.getMonth() + 1,
          0
        );
        that.confirmDate = newDate;
        if (newDate.getMonth() != new Date(Date.now()).getMonth()) {
          that.monthActive = 2;
          return;
        }
        that.onConfirm(that.confirmDate);
      } else {
        newDate.setMonth(newDate.getMonth() - that.monthActive + 1);
        that.minDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
        that.maxDate = new Date(
          newDate.getFullYear(),
          newDate.getMonth() + 1,
          0
        );
        if (that.monthActive != 1) {
          if (that.confirmDate.getMonth() == that.maxDate.getMonth()) {
            that.onConfirm(that.confirmDate);
          } else {
            that.onConfirm(that.maxDate);
          }
        } else {
          that.onConfirm(new Date(Date.now()));
        }
      }

      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatWokerMonthInfo",
            Params: [
              that.$route.query.ID,
              that.$route.query.Code,
              that.userInfo.loginType,
              that.confirmDate.getFullYear() +
                "-" +
                (that.confirmDate.getMonth() + 1) +
                "-1"
            ]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.listDate = response.data.Table;
            if (response.data.Table1.length > 0) {
              that.showRight = true;
              that.YDKQ = response.data.Table1[0];
            }
          } else {
            Dialog({ message: response.data.msg });
          }
        })
        .catch(error => {
          //弹出失败提醒
          Dialog({ message: error.message });
        });
    },
    formatter(day) {
      this.listDate.filter(item => {
        if (this.isSameDay(new Date(item.DATE), day.date)) {
          day.className = "zc";
          day.bottomInfo = "在场";
        }
      });
      return day;
    },
    isSameDay(dateA, dateB) {
      return dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0);
    },
    onSelect(item) {
      this.showAction = false;
      console.log(item);
    },
    afterKqzpRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      this.updateRm(file);
    },
    //上传base64图片到服务器
    updateRm(data) {
      var that = this;
      that.imageCompress(data.content, 1024).then(data_con => {
        that
          .$axios({
            method: "post",
            url: "/api/Tool",
            data: {
              Method: "uploadImg",
              ImgBuffer: data_con
            },
            headers: {
              Authorization: "Bearer " + that.userInfo.token
            }
          })
          .then(response => {
            if (response.data.status == "200") {
              that.kqzp = [
                {
                  url:
                    response.data.imgPath == null || response.data.imgPath == ""
                      ? ""
                      : response.data.imgPath
                }
              ];
            } else {
              Dialog({ message: "图片上传是失败" });
            }
            data.status = "done";
            data.message = "";
          })
          .catch(error => {
            data.status = "done";
            data.message = "";
            //弹出失败提醒
            Dialog({ message: error.message });
          });
      });
    },
    onYDKQ() {
      var that = this;
      if ((that.kqzp.length > 0 ? that.kqzp[0].url : "") == "") {
        Dialog({ message: "请上传考勤照片" });
        return;
      }
      that.loadingfinished = true;
      this.showAction = false;
      that
        .$axios({
          method: "post",
          url: "/api/Tool",
          data: {
            Method: "YDKQ",
            WorkerCode: that.YDKQ.WorkerCode,
            Type: that.radio,
            scoreLine: that.YDKQ.scoreLine,
            KQZP: that.kqzp[0].url,
            RYZP: that.YDKQ.RYZP
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.onConfirm(new Date(Date.now()));
            Dialog({ message: "完成考勤" });
            that.loadingfinished = false;
          } else {
            Dialog({ message: response.data.msg });
            that.loadingfinished = false;
          }
        })
        .catch(error => {
          //弹出失败提醒
          Dialog({ message: error.message });
          that.loadingfinished = false;
        });
    },
    imageCompress(base64, maxh) {
      let Img = new Image();
      var dataURL = "";
      Img.src = base64;
      let p = new Promise(function(resolve) {
        Img.onload = function() {
          //要先确保图片完整获取到，这是个异步事件
          let canvas = document.createElement("canvas"), //创建canvas元素
            width = Img.width, //确保canvas的尺寸和图片一样
            height = Img.height;
          // 默认将长宽设置为图片的原始长宽，这样在长宽不超过最大长度时就不需要再处理
          let ratio = width / height,
            maxLength = maxh,
            newHeight = height,
            newWidth = width;
          // 在长宽超过最大长度时，按图片长宽比例等比缩小
          if (width > maxLength || height > maxLength) {
            if (width > height) {
              newWidth = maxLength;
              newHeight = maxLength / ratio;
            } else {
              newWidth = maxLength * ratio;
              newHeight = maxLength;
            }
          }
          canvas.width = newWidth;
          canvas.height = newHeight;
          canvas.getContext("2d").drawImage(Img, 0, 0, newWidth, newHeight); //将图片绘制到canvas中
          dataURL = canvas.toDataURL("image/jpeg", 0.6); //转换图片为dataURL
          resolve(dataURL);
        };
      });
      return p;
    }
  },
  created: function() {
    const u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  }
};
</script>
